import { useState } from "react";

export enum FestivalMainTab {
  INTERVIEW = "INTERVIEW",
  RANK = "RANK",
  NEWS = "NEWS",
}

export enum FestivalCompetitionTab {
  EVENT = "EVENT",
  POSTER = "POSTER",
  NEWS = "NEWS",
}

export enum RabbitFestivalPage {
  MAIN = "MAIN",
  INTERVIEW = "INTERVIEW",
  COMPETITIONS = "COMPETITIONS",
  COMPETITION = "COMPETITION",
  EVENT = "EVENT",
}

export const useRabbitFestivalTab = () => {
  // 페이지
  const [festivalPage, setFestivalPage] = useState(RabbitFestivalPage.MAIN);
  // 메인 페이지 탭
  const [mainTab, setMainTab] = useState(FestivalMainTab.INTERVIEW);
  // 대회 페이지 탭
  const [competitionTab, setCompetitionTab] = useState(
    FestivalCompetitionTab.EVENT
  );

  const isFestivalPage = (tab: RabbitFestivalPage) => festivalPage === tab;
  const isMainTab = (tab: FestivalMainTab) => mainTab === tab;
  const isCompetitionTab = (tab: FestivalCompetitionTab) =>
    competitionTab === tab;

  return {
    // 페이지
    festivalPage,
    setFestivalPage,
    isFestivalPage,
    // 메인탭
    mainTab,
    setMainTab,
    isMainTab,
    // 대회탭
    competitionTab,
    setCompetitionTab,
    isCompetitionTab,
  };
};
